import { Container, Padding, Row, SizedBox } from "./CommonBaseComponents";
import { C4Text, T2Text } from "./text/CustomText";
import CustomIcon from "./image/CustomIcon";
import CustomImage from "./image/CustomImage";
import { useDevice } from "../hooks/useDevice";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useClickOutside } from "../hooks/useClickOutside";
import styled from "styled-components";
import LanguageDropdownMenu, { Languages } from "./dropdown/LanguageDropdownMenu";
import LocalStorageKey from "../enums/LocalStorageKey";
import { Theme } from "../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export function formatCurrentTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function PageTitle({ title, contentLength, hasHistoryBack, button }) {
    const currentDevice = useDevice();
    const navigate = useNavigate();

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => {
            clearInterval(timerId);
        };
    }, []);

    let titleSection;
    let countrySection;

    if (!contentLength) {
        titleSection = (
            <Row>
                {hasHistoryBack && (
                    <>
                        <CustomIcon iconName={"undo"} size={"36px"} onClick={() => navigate(-1)} cursor={"pointer"} />
                        <SizedBox width={"16px"} />
                    </>
                )}
                <T2Text>{title}</T2Text>
            </Row>
        );
    } else {
        titleSection = (
            <Row>
                <T2Text>{title}</T2Text>
                <SizedBox width={"8px"} />
                <Container padding={"4.5px 10px"} borderRadius={"50px"} border={`1px solid ${Theme.color.neutral200}`}>
                    <C4Text fontColor={Theme.color.zinc850} fontWeight={"400"}>
                        {contentLength}
                    </C4Text>
                </Container>
            </Row>
        );
    }

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentLanguage] = useState(() => localStorage.getItem(LocalStorageKey.language) || "en");
    const languageButtonRef = useRef(null); // 언어 버튼 ref 추가

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, (event) => {
        if (isMenuOpen) {
            const dropdown = document.querySelector('[data-is-dropdown="true"]');
            if (dropdown && dropdown.contains(event.target)) {
                return;
            }
            setIsMenuOpen(false);
        }
    });

    const handleLanguageChange = (newLang) => {
        localStorage.setItem(LocalStorageKey.language, newLang);
        window.location.reload();
    };

    if (currentDevice === "mobile" || currentDevice === "tablet") {
        countrySection = <></>;
    } else {
        countrySection = (
            <Row width={"auto"}>
                <CustomIcon iconName={"alarm"} size={"13.5px"} />
                <SizedBox width={"6px"} />
                <C4Text
                    fontColor={Theme.color.gray500}
                    style={{
                        fontVariantNumeric: "tabular-nums",
                        textAlign: "left",
                        width: 108,
                        whiteSpace: "nowrap",
                    }}
                >
                    {formatCurrentTime(currentTime)}
                </C4Text>
                <SizedBox width={"25px"} />
                <MenuContainer ref={menuRef}>
                    <Container
                        ref={languageButtonRef} // ref 연결
                        padding={"6px"}
                        borderRadius={"100%"}
                        border={`1px solid ${Theme.color.neutral200}`}
                        cursor={"pointer"}
                        onClick={toggleMenu}
                        hoverBackgroundColor={Theme.color.neutral100}
                    >
                        <CustomImage
                            imageName={
                                Languages.filter((v) => {
                                    return v.value === currentLanguage;
                                })[0]?.image
                            }
                            size={"24px"}
                            cursor={"pointer"}
                            borderRadius={"100%"}
                        />
                    </Container>
                    {isMenuOpen && (
                        <LanguageDropdownMenu
                            initValue={currentLanguage}
                            setValue={handleLanguageChange}
                            values={Languages}
                            onClose={toggleMenu}
                            anchorEl={languageButtonRef.current} // anchorEl 전달
                        />
                    )}
                </MenuContainer>
            </Row>
        );
    }

    return (
        <Row justifyContent={"space-between"}>
            <Padding padding={"0 12px"}>{titleSection}</Padding>
            {countrySection}
            {button}
        </Row>
    );
}
